'use strict';
function CoverOfferingResolverService(MODULE_INFO) {
	function resolve(quote) {
		switch (MODULE_INFO.id) {
			case 'home':
				return quote.dwellings[0].offering;
			case 'bike':
			case 'vehicle' :
			case 'caravan':
				return null;
			default:
				throw 'Unknown module info';
		}
	}

	return {
		resolve: resolve
	}
}
